import { DataBean } from "../DataBean";

export class PriceListFreightRate extends DataBean {



    public async deletePriceListFreightRate(idPriceListFreightRate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deletePriceListFreightRate_Number", [idPriceListFreightRate]);
    }
    public async addPriceListFreightRate(idPriceList: any, idTransportRoute: any, transportType: any, idCurrency: any, value: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.PriceListFreightRate_addPriceListFreightRate_Number_Number_Number_Number_Number_Number", [idPriceList, idTransportRoute, transportType, idCurrency, value, idEmployee]);
    }

    public async getPriceListFreightRateCatalog(idTransportRoute: any, idPriceList: any, transportServiceType: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPriceListFreightRateCatalog_Number_Number_Number_Number_Number", [idTransportRoute, idPriceList, transportServiceType, page, recordsPerPage]);
    }

}